module.exports = __webpack_public_path__ + "img/trash.0f138466.svg";